import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-52d59de2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "que-section" }
const _hoisted_2 = { ref: "refMainCon" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_page = _resolveComponent("loading-page")!
  const _component_dot_que_half_screen = _resolveComponent("dot-que-half-screen")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["m-que-box-fake", { 'only-options': $setup.dotMap?.[$setup.currentIndex]?.show_type === $setup.displayRangeMap.QUE_OPTIONS }]),
      style: _normalizeStyle($setup.styleObject.queFakeBoxStyle)
    }, [
      _createElementVNode("div", {
        class: "u-fold",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.dofold && $setup.dofold(...args)))
      }),
      _createElementVNode("div", {
        class: _normalizeClass(["m-que-box", {
          'only-options': $setup.dotMap?.[$setup.currentIndex]?.show_type === $setup.displayRangeMap.QUE_OPTIONS
        }]),
        ref: "refQueBox",
        style: _normalizeStyle($setup.styleObject.queBoxStyle)
      }, [
        _withDirectives(_createElementVNode("div", {
          class: "u-close",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.doCloseHalfView && $setup.doCloseHalfView(...args)))
        }, null, 512), [
          [_vShow, $setup.closeVisible]
        ]),
        _createElementVNode("div", {
          class: "m-current-box",
          ref: "refCurrentBox",
          style: _normalizeStyle($setup.styleObject.queInnerBoxStyle)
        }, [
          ($setup.loading)
            ? (_openBlock(), _createBlock(_component_loading_page, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dotMap, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (item.interact_question_cfg.length && $setup.currentIndex && index === $setup.currentIndex)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (item.isLoaded && index === $setup.currentIndex)
                        ? (_openBlock(), _createBlock(_component_dot_que_half_screen, {
                            key: 0,
                            isCurrent: $setup.currentIndex === index,
                            curTime: $setup.curTime,
                            displayRange: item.show_type,
                            questionList: item.interact_question_cfg,
                            dotIndex: index,
                            onHandleAfterRender: $setup.handleAfterRender,
                            class: _normalizeClass({ 'u-current-tile': index === $setup.currentIndex }),
                            onHandleChooseOption: $setup.handleChooseOption
                          }, null, 8, ["isCurrent", "curTime", "displayRange", "questionList", "dotIndex", "onHandleAfterRender", "class", "onHandleChooseOption"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ], 512),
          ($setup.isAfterSubmit)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "m-current-box-mask",
                onClick: _withModifiers(() => {}, ["stop"])
              }))
            : _createCommentVNode("", true)
        ], 4)
      ], 6)
    ], 6), [
      [_vShow, !$setup.queFolded]
    ]),
    ($setup.queFolded)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "u-extend",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.queFolded = false))
        }))
      : _createCommentVNode("", true)
  ]))
}